import { BuiltInComponents } from 'craft/constants';
import { CATEGORIES, INTERACTION_TYPES } from 'craft/types';

import { interactions } from './constants';

const hotspotInteractions = [
  INTERACTION_TYPES.DismissAndOpenNextHotspot,
  INTERACTION_TYPES.Dismiss,
  INTERACTION_TYPES.DismissHotspot,
  INTERACTION_TYPES.DismissHotspotGroup,
];
const tourInteractions = [INTERACTION_TYPES.Dismiss, INTERACTION_TYPES.DismissTour];

export interface GetAvailableActionsProps {
  rootName: string;
  isInForm: boolean;
  isMultistepForm: boolean;
  isInFlow: boolean;
  withModals: boolean;
  withLegacyModals: boolean;
  withTours: boolean;
  withHotspots: boolean;
}

export const getAvailableActions = ({
  rootName,
  isInForm,
  isMultistepForm,
  isInFlow,
  withModals,
  withLegacyModals,
  withTours,
  withHotspots,
}: GetAvailableActionsProps) => {
  const hasFlowInteractions = isInFlow || isMultistepForm;

  const isInModal = rootName === BuiltInComponents.Modal;
  const isInHotspot = rootName === BuiltInComponents.HotspotGroup;
  const isInTour = rootName === BuiltInComponents.Tour;

  return interactions
    .filter(
      (label) => withModals || withLegacyModals || label.id !== INTERACTION_TYPES.TriggerModal,
    )
    .filter((label) => isInTour || tourInteractions.indexOf(label.id) === -1)
    .filter((label) => isInHotspot || hotspotInteractions.indexOf(label.id) === -1)
    .filter((label) => !isInHotspot || !isInTour || label.id !== INTERACTION_TYPES.Content)
    .filter((label) => isInModal || label.id !== INTERACTION_TYPES.DismissModal)
    .filter((label) => !isInModal || label.id !== INTERACTION_TYPES.TriggerModal)
    .filter((label) => withTours || label.id !== INTERACTION_TYPES.TriggerTour)
    .filter((label) => withHotspots || label.id !== INTERACTION_TYPES.TriggerHotspotGroup)
    .filter((label) => isInForm || label.id !== INTERACTION_TYPES.FormSubmit)
    .filter((label) => hasFlowInteractions || label.category !== CATEGORIES.FLOW)
    .filter((label) => isInTour || label.category !== CATEGORIES.TOUR);
};
